import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { companySearchShape } from "../../../features/accounting/company.js";
import { todayIstanbul } from "../../../features/accounting/shared.js";
import { TreasuryPage, useFinanceCrumb } from "../../../features/treasury/shared.js";
import { TreasuryTransactionForm } from "../../../features/treasury/transaction-form.js";
import { TREASURY_FORM_TYPES } from "../../../features/treasury/treasury-values.js";

const searchSchema = z.object({
  ...companySearchShape,
  /** Kasa / banka ekranından gelindiğinde hareket türü hazır seçilir. */
  type: z.enum(TREASURY_FORM_TYPES).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/finans/hareket-yeni")({
  validateSearch: (search) => searchSchema.parse(search),
  component: NewTreasuryTransactionPage,
});

function NewTreasuryTransactionPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const listCrumb = useFinanceCrumb("/finans/kasalar", "menu.cashRegisters");
  const search = Route.useSearch();

  return (
    <TreasuryPage
      title={t("treasury.txn.new")}
      description={t("treasury.txn.newDescription")}
      breadcrumb={[listCrumb, { label: t("treasury.txn.new") }]}
    >
      {({ companyId }) => (
        <TreasuryTransactionForm
          companyId={companyId}
          initialType={search.type ?? "CASH_IN"}
          today={todayIstanbul()}
          onSaved={() => void navigate({ to: "/finans/hareketler" })}
        />
      )}
    </TreasuryPage>
  );
}
